import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

/**
 * A **per-request, short-lived, authorized** read of one asset (N12).
 *
 * This is the only way bytes are ever readable: there is no public bucket and no
 * stable URL, so a link that leaks stops working within
 * `media.readUrlTtlSeconds`. The api mints it *after* checking that the caller
 * owns the asset or holds the kind's staff permission — and, for verification
 * evidence, after writing the audit row.
 *
 * `expiresAt` is not decoration: it is the difference between a private bucket
 * and a public one with extra steps.
 *
 * `mime` is the type finalize verified — a viewer branches on it (an image
 * element or a cross-origin document frame) before touching the bytes (F1).
 */
export const MediaUrlSchema = z
  .object({
    mediaId: UuidSchema,
    url: z.url(),
    expiresAt: z.iso.datetime(),
    mime: z.string().min(1),
  })
  .strict();

export type MediaUrl = z.infer<typeof MediaUrlSchema>;
